<template>
  <div class="contract-detail-scroll" v-loading="loading" element-loading-background="var(--theme-bg)" :aria-busy="loading" tabindex="0" aria-label="合约详情">
    <p v-if="!contractId" class="detail-state">暂无合约</p>
    <p v-else-if="failed" class="detail-state" role="alert">合约详情加载失败 <button type="button" @click="load">重试</button></p>
    <dl v-else-if="info" class="contract-detail-list">
      <div v-for="(row, index) in rows" :key="row.label" :class="{ total: index === 0, wide: row.wide }"><dt>{{ row.label }}<button v-if="index === 0" type="button" class="agreement-button" @click="agreementVisible = true">配资合同</button></dt><dd :class="row.tone">{{ row.value }}</dd></div>
    </dl>
    <el-dialog title="配资合同" :visible.sync="agreementVisible" width="min(900px, 94vw)" top="6vh" append-to-body custom-class="stock-agreement-dialog">
      <ContractAgreement v-if="agreementVisible && info" :market="market" :info="info" />
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
import { contractDetails } from './contractDetails'
import ContractAgreement from './ContractAgreement.vue'
export default {
  components: { ContractAgreement },
  props: { market: String, contractId: [Number, String], revision: Number, liveInfo: Object },
  data: () => ({ info: null, loading: false, failed: false, sequence: 0, agreementVisible: false }),
  computed: {
    requestKey() { return `${this.market}:${this.contractId}:${this.revision}` },
    rows() { const live = this.liveInfo && Number(this.liveInfo.id) === Number(this.contractId) ? this.liveInfo : {}; return contractDetails(this.market, { ...this.info, ...live }) }
  },
  watch: { requestKey: 'load' },
  mounted() { this.load() },
  beforeDestroy() { this.sequence++ },
  methods: {
    async load() {
      const sequence = ++this.sequence
      this.info = null; this.failed = false; this.loading = false; this.agreementVisible = false
      if (!this.contractId) return
      this.loading = true
      try {
        const hk = this.market === 'hk' || this.market === 'us'
        const info = await request({ url: `vexe/v1/${hk ? 'contract' : 'consult'}/contractInfo`, method: 'get', params: hk ? { contract_id: this.contractId } : { id: this.contractId, is_profit: 0, has_profit_loss: 1 } })
        if (sequence !== this.sequence) return
        if (!info || !info.id) throw new Error('Missing contract detail')
        this.info = info
      } catch (_) { if (sequence === this.sequence) this.failed = true }
      finally { if (sequence === this.sequence) this.loading = false }
    }
  }
}
</script>
<style scoped>
.contract-detail-scroll { position: relative; flex: 1 1 0; min-height: 0; min-width: 0; overflow-y: auto; overscroll-behavior: contain; padding: 12px; }
.contract-detail-scroll ::v-deep .el-loading-spinner .path { stroke: var(--theme-accent); }
.contract-detail-list { display: block; margin: 0; font-size: 13px; line-height: 1.6; }
.contract-detail-list > div { display: flex; justify-content: space-between; gap: 12px; padding: 5px 0; }
dt { flex-shrink: 0; color: var(--theme-muted); }
dd { min-width: 0; margin: 0; text-align: right; overflow-wrap: anywhere; }
dd.green { color: var(--theme-success); }
dd.red { color: var(--theme-danger); }
.contract-detail-list > .total { display: block; padding-bottom: 12px; }
.total dd { text-align: left; font-size: 28px; color: var(--theme-accent); }
.total dt { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.agreement-button { flex-shrink: 0; padding: 0; font-size: 12px; }
.contract-detail-list > .wide { display: block; }
.wide dd { text-align: left; }
.detail-state { color: var(--theme-muted); text-align: center; }
button { border: 0; background: transparent; color: var(--theme-accent); font: inherit; cursor: pointer; }
</style>
